import { ChangePasswordForm } from '@/components/ChangePasswordForm';
import { Card, CardContent } from '@/components/ui/Card';

export function AdminSettings() {
  return (
    <Card className="rounded-lg shadow">
      <CardContent>
        <div className="mt-2 border-b bg-white">
          <div className="container mx-auto px-4 py-6">
            <h1 className="text-2xl font-bold text-gray-900">
              Security Settings
            </h1>
            <p className="mt-1 text-gray-600">
              Manage your account security and privacy settings
            </p>
          </div>
        </div>
        <div className="rounded-lg">
          <div className="container mx-auto space-y-6 px-4 py-6">
            <ChangePasswordForm />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
